import React from 'react'
import PrivacyAndPolicy from '../../components/PrivacyAndPolicyComp/PrivacyAndPolicy'

const PrivacyPolicyPage = () => {
  return (
    <div>
        <PrivacyAndPolicy />
    </div>
  )
}

export default PrivacyPolicyPage